import CompanyContactGenerated, { CompanyContactGeneratedEntityManager } from './generated/CompanyContact.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';
import { CompanyContactTranslation } from './CompanyContactTranslation';


export class CompanyContactEntityManager extends CompanyContactGeneratedEntityManager<CompanyContactTranslation, CompanyContact>
{
    constructor()
    {
        super({
            createEntity: () => new CompanyContact(),
        });
    }
}


export class CompanyContact extends CompanyContactGenerated<CompanyContactTranslation>
{
    static _manager: CompanyContactEntityManager;
    static get manager(): CompanyContactEntityManager
    {
        if (!this._manager) this._manager = new CompanyContactEntityManager();
        return this._manager;
    }
}


export default CompanyContact;